import { render } from "./NotFound.vue?vue&type=template&id=1c07c2cc&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=1c07c2cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c07c2cc"]])

export default __exports__